export default class User {
  constructor(email, password, resetPasswordToken, companyCode, companyType, companyName, companyAddress, buildingNumber, city, postcode, countryCode, phoneNumber) {
    this.email = email;
    this.password = password;
    this.resetPasswordToken = resetPasswordToken
    this.companyCode = companyCode;
    this.companyType = companyType;
    this.companyName = companyName;
    this.companyAddress = companyAddress;
    this.buildingNumber = buildingNumber;
    this.city = city;
    this.postcode = postcode;
    this.countryCode = countryCode;
    this.phoneNumber = phoneNumber;
  }
}
